import axios, {AxiosResponse, CancelToken} from 'axios';
import {CANCEL} from 'redux-saga';

import Url from '../constants/Url';

class GameXpHighlightsApi {
    getData(params) {
        const source = axios.CancelToken.source();
        const cancelToken: CancelToken = source.token;

        const request: Promise<AxiosResponse<string>> = axios
            .get(Url().GET_GAME_XP_HIGHLIGHTS, {
                params,
                cancelToken,
                headers: {'Cache-control': 'no-store', Pragma: 'no-cache'}
            })
            .then(response => response.data)
            .catch(ex => {
                console.error('Failed to getData:', ex.message);
                throw ex;
            });

        request[CANCEL] = () => source.cancel();

        return request;
    }
}

export default new GameXpHighlightsApi();
